import { Component } from '@angular/core';
import {LoadingController, NavController, NavParams, Platform, ViewController} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";


@Component({
  selector: 'page-all-progress-report',
  templateUrl: 'all-progress-report.html',
})
export class AllProgressReportPage {


  ProgressData: any;
  AllSorceData: any;

  School = 'All';
  SchoolData = {};

  hide = 0;

  constructor(public navCtrl: NavController,
              public service: ServiceProvider,
              public viewCtrl: ViewController,
              public platform: Platform,
              public loadingCtrl: LoadingController,
              public navParams: NavParams) {

    this.platform.ready().then(() => {

      this.SchoolData = {
        "All": 0,
        "GWW": 2,
        "GWE": 3,
        "GEIS": 1
      };
      this.loadvalues(this.SchoolData[this.School]);
    });
  }

  active_tab(tab) {
    this.hide = 0;
    console.log(tab);
    this.School = tab;
    this.loadvalues(this.SchoolData[this.School]);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AllProgressReportPage');
  }

  loadvalues(schoolId) {

    this.hide = 0;

    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });

    loading.present();

    this.ProgressData = [];
    this.AllSorceData = [];

    this.service.httpcall('app_web_service/get_progress_activeNotEqualtoZero?SchoolId=' + schoolId).subscribe(data => {

      this.ProgressData = data;
      this.hide = 1;
      this.AllSorceData = data['Data']['Sub_ststus'];

      // if(this.ProgressData.length != null){
      //
      // }else{
      //
      // }

      loading.dismiss();
    })
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    this.loadvalues(this.SchoolData[this.School]);

    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }

  backBTN() {
    this.viewCtrl.dismiss();
  }



}



// WEBPACK FOOTER //
// ./src/pages/all-progress-report/all-progress-report.ts